import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Komitent } from './komitent';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-komitent-modal-update',
  templateUrl: './komitent-modal-update.component.html'
})
export class KomitentModalUpdateComponent extends BaseModalUpdateComponent<Komitent> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Komitent>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
